import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import NavigateUpButton from './NavigateUpButton';
import AddEntityButton from './AddEntityButton';

const NodeHeader = ({ catalog, node }) => (
  <div className="ui menu">
    <NavigateUpButton node={node} />
    <div className="header item">
      <h3>{node.parent ? node.title : 'Racine'}</h3>
    </div>
    {node.parent === null && (
      <div className="item">
        <Link to={`/nodes/${node.id}/edit`} className="ui labeled icon button">
          <i className="edit icon" />
          Editer
        </Link>
      </div>
    )}
    <div className="right menu">
      <div className="ui item">
        <AddEntityButton catalog={catalog} node={node} />
      </div>
      <div className="item">
        <Link
          to={`/nodes/${node.id}/new`}
          className="ui right floated labeled icon button"
        >
          <i className="plus icon" />
          Ajouter un noeud libre
        </Link>
      </div>
    </div>
  </div>
);

NodeHeader.propTypes = {
  catalog: PropTypes.string.isRequired,
  node: PropTypes.object.isRequired,
};

export default NodeHeader;



// WEBPACK FOOTER //
// ./src/modules/catalog/components/NodeHeader.js